import React from 'react';

import { i18n } from 'core/localization';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { LogEntryFormConfig } from '../../types';
import { LogEntryForm } from './logEntryForm';
import { LogEntryFormStore } from './logEntryFormStore';

export const openLogEntryForm = (config: LogEntryFormConfig) => {
	const store = new LogEntryFormStore(config);

	const modal = openModal(
		() => ({
			title: i18n('Create log entry'),
			mode: 'create',
			width: 500,
			resizable: false,
			positionType: config.positionType ?? ModalPosition.Centered,
			positionAnchor: config.positionAnchor,
			mask: { closable: false },
			okButtonProps: { disabled: store.okDisabled, loading: store.saving },
			onOk: async (e) => {
				e.preventDefault();
				if (await store.save()) {
					modal.close(true);
					store.destroy();
				}
			},
			onCancel: () => {
				config.onCancel?.();
				store.destroy();
			},
		}),
		<LogEntryForm store={store} />,
	);

	return modal;
};
